export enum AwardType {
	Orpetron = 'Orpetron',
	CSSDesignAwards = 'CSS Design Awards',
	ClutchAwards = 'Clutch Awards',
	FWA = 'FWA',
	WorldBrandDesignAwards = 'World Brand Design Awards',
	Awwwards = 'Awwwards'
}
